import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getToken } from "../../helpers";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchInvoices = createAsyncThunk(
  "invoice/fetchInvoices",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.get(`/invoices`);

      if (!response.data) {
        console.error("Нет данных в ответе");
        return rejectWithValue("Нет данных");
      }

      return response.data;
    } catch (error) {
      console.error("Ошибка при запросе:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const fetchCurrentInvoice = createAsyncThunk(
  "invoice/fetchCurrentInvoice",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.get(`/invoices/current`);

      if (!response.data) {
        console.error("Нет данных в ответе");
        return rejectWithValue("Нет данных");
      }

      return response.data;
    } catch (error) {
      console.error("Ошибка при запросе:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    invoices: [],
    currentInvoice: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCurrentInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.currentInvoice = action.payload;
      })
      .addCase(fetchCurrentInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default invoiceSlice.reducer;
